import get from "lodash/get";
import Api from "@/Services/Api";

export default {
    methods: {
        applyConfig() {
            const config = window.centralAdminOrderForm;

            this.$store.state.type = get(config, 'type', 'form');
            this.$store.state.config.headerOffset = get(config, 'config.headerOffset', 0);
            this.$store.state.config.termsAndConditions = get(config, 'config.termsAndConditions', null);

            this.$store.state.config.locale = get(config, 'config.locale', 'en');
            Api.setLocale(this.$store.state.config.locale);

            Api.init();
        },
    },
};
